var Grafs;
(function($){

    Grafs = {

        $grafs : null,

        init : function(){

            this.$grafs = $( '.grafico' );
            if( !this.$grafs.length ) return false;

            // Configure each block
            for( var gs = 0;  gs < Grafs.$grafs.length; gs++ ){
                Grafs.configure( Grafs.$grafs.eq( gs ) );   
            }

        },

        configure : function( $g ){

            // Data
            var data = $g.data( 'Grafs' );
            if( data !== undefined ) return false;
            
            data = {
                $ : $g,
                $cols: $( 'li', $g ),
                $total: $( '#' + $g.data( 'total-id' ) ),
                maxValue: 0
            };
            data.$totalInt = data.$total.children( 'strong' );

            if( !data.$cols.length ) return false;
            data.totalItems = data.$cols.length;

            // Keep data
            $g.data( 'Grafs', data );

            data.$cols.each(function( ci ){

                this.$ = this.$ || $( this );

                var cdata = {
                    _ : this,
                    $ : this.$,
                    $year : $( 'strong', this.$ ),
                    $total : $( 'em', this.$ ),
                    $bar : $( 'div', this.$ ),
                    total : parseInt( this.$.data( 'total' ) ),
                    percent : parseInt( this.$.data( 'percent' ) )
                };

                if( cdata.total > data.maxValue ){
                    data.maxValue = cdata.total;
                }

                this.$.data( 'Grafs', cdata );

            });

            data.duracao = Math.ceil( data.maxValue / 5.5 );

            data.$.waypoint(function(){
                Grafs.animaGrafico( data.$.data( 'Grafs' ) );   
            },{ offset: '70%' });

        },

        startAnimations : function(){
            for( var gs = 0;  gs < Grafs.$grafs.length; gs++ ){
                Grafs.animaGrafico( Grafs.$grafs.eq( gs ).data( 'Grafs' ) );   
            }
        },

        animaGrafico : function( data ){

            var time = data.duracao;
            var interval = setInterval(function(){
                
                //var totalAll = 0;

                time--;
                if( time <= 0 ) clearInterval( interval );

                for( var ti = 0; ti < data.totalItems; ti++ ){                    

                    var cdata = data.$cols.eq( ti ).data( 'Grafs' );
                    var actual = parseInt( cdata.$total.text() );

                    if( time === ( data.duracao - 1 ) ){

                        // Total
                        data.$total.addClass( 'on' );

                        // Ítem
                        var _quoc = cdata.percent / 100;
                        var _height = 'calc( 85px + ( ( 100% - 85px ) * ' + _quoc + ' ) )';
                        cdata.$.css( 'height', _height ).addClass( 'on' );
                    
                    }
                    
                    if( actual < cdata.total ){

                        var step = parseInt( Math.ceil( cdata.total / data.duracao ) );
                        if( step < 1 ) step = 1;

                        var new_total = ( actual + step );
                        new_total = new_total > cdata.total ? cdata.total : new_total;

                        //totalAll += new_total

                        cdata.$total.text( new_total );
                    
                    }
                    else {

                        //totalAll += actual;
                    
                    }     
                    
                    // Total é o último número
                    var _total_all = parseInt( new_total );
                    if( ti === ( data.totalItems - 1 ) && !isNaN( _total_all ) ){
                        data.$totalInt.text( _total_all.toLocaleString() );
                    }


                }

                //data.$totalInt.text( totalAll.toLocaleString() );

            }, 1 );

        }

    };
    $(function(){
        Grafs.init();
    });

})(jQuery);